<template>
  <div class="class-list">
    <GlobalInfoBar
      title="补充绩效账户"
      :content="`当前账户余额：${accountBalance}元`"
      icon="shop"
      inline
    >
      <template slot="titleRight">
        <el-tag size="mini" type="danger" effect="plain">补充绩效账户</el-tag>
      </template>
      <template slot="contentRight">
        <img
          class="refresh-icon"
          :class="{ 'is-rotating': isBalanceRefreshing }"
          src="@/assets/images/refresh.png"
          alt=""
          @click="handleBalanceRefresh"
        />
      </template>
      <template slot="rightSlot">
        <el-button type="text" @click="openAdjustDialog">账户调账</el-button>
      </template>
    </GlobalInfoBar>

    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <GlobalForm
          :init-data="queryForm"
          :form-item-list="formItemList"
          :inline="true"
          :labelWidth="92"
          :needBtnLoading="true"
          round
          confirmBtnName="查询"
          @handleConfirm="handleSearch"
        >
          <el-form-item slot="storeId" label="所属门店" style="margin:0">
            <el-select v-model="storeId" placeholder="请选择所属门店" filterable clearable @change="handleChangeStore">
              <el-option
                v-for="item in storeList"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </el-form-item>
          <el-form-item slot="opt" label="账单类型" style="margin:0">
            <el-select v-model="opt" placeholder="请选择账单类型查询" filterable clearable @change="handleChangeOpt">
              <el-option v-for="item in optList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item slot="serTypeList" label="账单子类型" style="margin:0">
            <el-select v-model="serType" placeholder="请选择账单子类型" filterable clearable>
              <el-option v-for="item in serTypeList" :key="item.key" :label="item.value" :value="item.key" />
            </el-select>
          </el-form-item>
          <el-button
            slot="AddSlot"
            type="success"
            icon="el-icon-download"
            :loading="exportLoading"
            @click="handleExport"
          >
            导出账单
          </el-button>
        </GlobalForm>
      </div>

      <GlobalTable
        ref="GlobalTable"
        v-loading="loading"
        :columns="tableColumns"
        :data="displayRows"
        :currentPage="page.pageNum"
        :pageSize="page.pageSize"
        :total="page.total"
        @handleCurrentChange="handleCurrentChange"
      >
        <el-table-column label="账单类型" slot="opt" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.opt === "01" ? "入账" : row.opt === "02" ? "出账" : "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="任务名称" slot="performanceName" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.performanceName||'--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="交易金额" slot="amount" align="center">
          <template slot-scope="{ row }">
            <span>{{ formatAmount(row.amount, row.opt) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发放职员ID" slot="companyStaffId" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.companyStaffId||"--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发放职员信息" slot="staffInfo" align="center">
          <template slot-scope="{ row }">
            <span>{{ formatStaffInfo(row) }}</span>
          </template>
        </el-table-column>
                <el-table-column label="所属门店" slot="companyName" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.storeName||'--'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="账单备注" slot="remark" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.remark || row.id ? row.remark || "--" : "" }}</span>
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>

    <el-dialog
      :visible.sync="adjustVisible"
      width="660px"
      custom-class="adjust-dialog"
      :close-on-click-modal="false"
      :show-close="false"
      @closed="resetAdjustForm"
    >
      <div class="drawer-card">
        <div class="drawer-header">
          <span>资金账户调整</span>
          <i class="el-icon-close" @click="adjustVisible = false"></i>
        </div>
        <div class="drawer-body">
          <el-form
            ref="adjustForm"
            :model="adjustForm"
            :rules="adjustRules"
            label-width="86px"
            size="small"
          >
            <el-form-item label="调整方式" prop="type">
              <el-radio-group v-model="adjustForm.type" class="adjust-type-radios">
                <el-radio-button label="income">调入补充绩效账户</el-radio-button>
                <el-radio-button label="outcome">调出补充绩效账户</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="调整金额" prop="amount">
              <el-input
                v-model.trim="adjustForm.amount"
                maxlength="10"
                :placeholder="amountPlaceholder"
                @input="limitMoney"
              >
                <template slot="append">元</template>
              </el-input>
              <div v-if="isBalanceInsufficient" class="amount-error">
                {{ outcomeAccount.name }}余额不足，当前可调{{ outcomeAccount.current }}元，还差{{ insufficientAmount }}元
              </div>
            </el-form-item>
          </el-form>

          <div class="account-preview">
            <div class="flow-title">
              <span>资金流向</span>
              <em>{{ flowText }}</em>
            </div>
            <div class="flow-card" :class="{ 'is-danger': isBalanceInsufficient }">
              <div class="flow-account flow-out">
                <div class="flow-label">调出账户</div>
                <div class="flow-account-name">{{ outcomeAccount.name }}</div>
                <div class="flow-balance">
                  当前 <strong>{{ outcomeAccount.current }}</strong> 元
                </div>
                <div class="flow-after">
                  调账后 <strong>{{ outcomeAccount.after }}</strong> 元
                </div>
              </div>
              <div class="flow-center">
                <div class="flow-amount">
                  <span>{{ adjustAmount ? adjustAmount : "--" }}</span>
                  <em>元</em>
                </div>
                <i class="el-icon-right"></i>
              </div>
              <div class="flow-account flow-in">
                <div class="flow-label">调入账户</div>
                <div class="flow-account-name">{{ incomeAccount.name }}</div>
                <div class="flow-balance">
                  当前 <strong>{{ incomeAccount.current }}</strong> 元
                </div>
                <div class="flow-after">
                  调账后 <strong>{{ incomeAccount.after }}</strong> 元
                </div>
              </div>
            </div>
            <div v-if="isBalanceInsufficient" class="balance-warning">
              <i class="el-icon-warning-outline"></i>
              <span>{{ outcomeAccount.name }}最多可调出{{ outcomeAccount.current }}元，请调整金额后再提交。</span>
            </div>
          </div>

          <div class="drawer-footer">
            <el-button size="small" @click="adjustVisible = false">取消</el-button>
            <el-button
              size="small"
              type="primary"
              :loading="adjustLoading"
              :disabled="isBalanceInsufficient"
              @click="submitAdjust"
            >
              确定
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import _api from "@/utils/request";

export default {
  name: "PerformanceBil",
  data() {
    return {
      accountBalance: 0,
      recycleBalance: 0,
      exportLoading: false,
      isBalanceRefreshing: false,
      adjustVisible: false,
      adjustLoading: false,
      operatorName: localStorage.getItem("userName") || "繁小星-admin",
      loading: false,
      searchParams: {},
      queryForm: {
        entryTime: [
          moment().day(moment().day() - 30).format("YYYY-MM-DD 00:00:00"),
          moment().format("YYYY-MM-DD 23:59:59"),
        ],
      },
      storeList: [],
      storeId: "",
      companyId: "",
      opt: "",
      serType: "",
      serTypeList: [],
      optList: [
        { value: "01", label: "入账" },
        { value: "02", label: "出账" },
      ],
      formItemList: [
        { slotName: "storeId" },
        {
          type: "input",
          labelName: "账单流水号",
          key: "uniqNo",
          placeholder: "请输入账单流水号查询",
        },
        { slotName: "opt" },
        { slotName: "serTypeList" },
        {
          type: "pickerOptions",
          labelName: "时间",
          key: "entryTime",
          placeholder: "请选择时间",
          valueFormat: "timestamp",
          lableWidth: "60",
          clearable: true,
        },
      ],
      adjustForm: {
        type: "income",
        amount: "",
      },
      adjustRules: {
        type: [{ required: true, message: "请选择调整类型", trigger: "change" }],
        amount: [
          { required: true, message: "请输入调整金额", trigger: "blur" },
          {
            pattern: /^(0|[1-9]\d*)(\.\d{1,2})?$/,
            message: "请输入正确金额，最多两位小数",
            trigger: "blur",
          },
        ],
      },
      filteredRows: [],
      tableColumns: [
        { label: "账单流水号", prop: "uniqNo" },
        { label: "账单时间", prop: "createTime" },
        { slotName: "opt" },
        { label: "账单子类型", prop: "title" },
        // { label: "任务名称", prop: "taskName" },
        {slotName: "performanceName"},
        {slotName: "companyStaffId"},
        { slotName: "staffInfo" },
        { slotName: "companyName" },
        { slotName: "amount" },
        { label: "当前余额", prop: "nowBalance" },
        { slotName: "remark" },
      ],
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  computed: {
    adjustAmount() {
      return Number(this.adjustForm.amount) || 0;
    },
    performanceAfterBalance() {
      var amount = this.adjustForm.type === "income" ? this.adjustAmount : -this.adjustAmount;
      return Number((this.accountBalance + amount).toFixed(2));
    },
    recycleAfterBalance() {
      var amount = this.adjustForm.type === "income" ? -this.adjustAmount : this.adjustAmount;
      return Number((this.recycleBalance + amount).toFixed(2));
    },
    amountPlaceholder() {
      return this.adjustForm.type === "income"
        ? "请输入调入补充绩效账户金额"
        : "请输入调出补充绩效账户金额";
    },
    flowText() {
      return this.outcomeAccount.name + " → " + this.incomeAccount.name;
    },
    isBalanceInsufficient() {
      return this.adjustAmount > 0 && this.adjustAmount > Number(this.outcomeAccount.current);
    },
    insufficientAmount() {
      var amount = this.adjustAmount - Number(this.outcomeAccount.current);
      return amount > 0 ? Number(amount.toFixed(2)) : 0;
    },
    incomeAccount() {
      if (this.adjustForm.type === "income") {
        return {
          name: "补充绩效账户",
          current: this.accountBalance,
          after: this.performanceAfterBalance,
        };
      }
      return {
        name: "回收资金账户",
        current: this.recycleBalance,
        after: this.recycleAfterBalance,
      };
    },
    outcomeAccount() {
      if (this.adjustForm.type === "income") {
        return {
          name: "回收资金账户",
          current: this.recycleBalance,
          after: this.recycleAfterBalance,
        };
      }
      return {
        name: "补充绩效账户",
        current: this.accountBalance,
        after: this.performanceAfterBalance,
      };
    },
    displayRows() {
      return this.filteredRows;
    },
  },
  created() {
    this.getCompanyAccountInfo();
    this.getSerTypeList();
    this.getStoreSelectOrder();
    this.handleSearch(this.queryForm);
  },
  methods: {
    handleSearch(data, done) {
      this.searchParams = {
        companyId: this.companyId || "",
        storeId: this.storeId || "",
        uniqNo: data.uniqNo || "",
        opt: this.opt || "",
        serType: this.serType || "",
        startTime: data.entryTime ? moment(data.entryTime[0]).format("x") : "",
        endTime: data.entryTime ? moment(data.entryTime[1]).format("x") : "",
        pageNum: 1,
        pageSize: 10,
      };
      this.page.pageNum = 1;
      this.getBillList(done);
    },
    buildBillParams(extraParams) {
      return Object.assign(
        {
          accountType: "companyPerformance",
          merchantId: "",
          companyId: this.searchParams.companyId || "",
          storeId: this.searchParams.storeId || "",
          uniqNo: this.searchParams.uniqNo || "",
          opt: this.searchParams.opt || "",
          serType: this.searchParams.serType || "",
          startTime: this.searchParams.startTime || "",
          endTime: this.searchParams.endTime || "",
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
        },
        extraParams || {}
      );
    },
    getBillList(done) {
      this.loading = true;
      _api
        .getAccountPayList(this.buildBillParams())
        .then((res) => {
          if (res.code === 1 && res.data) {
            this.filteredRows = res.data.records || [];
            this.page.total = res.data.total || 0;
            this.page.pageNum = res.data.current || this.page.pageNum;
          }
        })
        .finally(() => {
          this.loading = false;
          if (typeof done === "function") {
            done();
          }
        });
    },
    getSerTypeList() {
      _api.getSerTypeList({ opt: this.opt, accountType: "companyPerformance" }).then((res) => {
        if (res.code === 1) {
          this.serTypeList = res.data || [];
        }
      });
    },
    handleChangeOpt(val) {
      this.opt = val;
      this.serType = "";
      this.getSerTypeList();
    },
    handleChangeStore(val) {
      this.storeId = val;
      this.companyId = val;
    },
    getStoreSelectOrder() {
      _api.getStoreSelectOrder().then((res) => {
        if (res.code === 1) {
          this.storeList = res.data || [];
        }
      });
    },
    handleBalanceRefresh() {
      if (this.isBalanceRefreshing) {
        return;
      }
      this.isBalanceRefreshing = true;
      Promise.all([this.getCompanyAccountInfo(), this.getBillList()]).finally(() => {
        this.isBalanceRefreshing = false;
      });
    },
    handleReset() {
      this.queryForm = {
        entryTime: [],
      };
      this.storeId = "";
      this.companyId = "";
      this.opt = "";
      this.serType = "";
      this.searchParams = {};
      this.filteredRows = [];
      this.page.pageNum = 1;
      this.page.total = 0;
    },
    handleCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.getBillList();
    },
    handleExport() {
      this.exportLoading = true;
      _api
        .exportExcel(this.buildBillParams({ pageNum: 1, pageSize: this.page.pageSize }))
        .then((res) => {
          this.downloadBlob(res, "补充绩效账单.xlsx");
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    openAdjustDialog() {
      this.adjustVisible = true;
      this.operatorName = localStorage.getItem("userName") || "繁小星-admin";
      this.getCompanyAccountInfo();
    },
    getCompanyAccountInfo() {
      return _api.getCompanyAccountInfo().then((res) => {
        if (res.code === 1 && res.data) {
          this.recycleBalance = this.formatMoneyNumber(res.data.balance);
          this.accountBalance = this.formatMoneyNumber(res.data.performanceBalance);
        }
      });
    },
    resetAdjustForm() {
      this.adjustForm = {
        type: "income",
        amount: "",
      };
      if (this.$refs.adjustForm) {
        this.$refs.adjustForm.resetFields();
      }
    },
    limitMoney(value) {
      var money = String(value)
        .replace(/[^\d.]/g, "")
        .replace(/^\./, "")
        .replace(/\.{2,}/g, ".")
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      var match = money.match(/^\d+(\.\d{0,2})?/);
      this.adjustForm.amount = match ? match[0] : "";
    },
    submitAdjust() {
      var that = this;
      this.$refs.adjustForm.validate(function(valid) {
        if (!valid) {
          return;
        }
        var amount = Number(that.adjustForm.amount);
        if (amount > that.outcomeAccount.current) {
          that.$message.warning(that.outcomeAccount.name + "余额不足");
          return;
        }
        var params = {
          amountPrice: amount,
          cause: "",
          operationAccount: that.adjustForm.type === "income" ? "02" : "01",
        };
        that.adjustLoading = true;
        _api
          .adjustmentAccountPerformance(params)
          .then(function(res) {
            if (res.code === 1) {
              that.adjustVisible = false;
              that.$message.success("账户调整成功");
              that.getCompanyAccountInfo();
              that.getBillList();
            } else {
              that.$message.error(res.msg || "账户调整失败");
            }
          })
          .finally(function() {
            that.adjustLoading = false;
          });
      });
    },
    getNowTime() {
      var date = new Date();
      var pad = function(num) {
        return num < 10 ? "0" + num : num;
      };
      return (
        date.getFullYear() +
        "-" +
        pad(date.getMonth() + 1) +
        "-" +
        pad(date.getDate()) +
        " " +
        pad(date.getHours()) +
        ":" +
        pad(date.getMinutes()) +
        ":" +
        pad(date.getSeconds())
      );
    },
    formatAmount(amount, opt) {
      if (amount === "" || amount === undefined || amount === null) {
        return "";
      }
      var number = Number(amount);
      if (Number.isNaN(number)) {
        return String(amount);
      }
      var absAmount = String(amount).replace(/^[+-]/, "");
      if (opt === "01") {
        return "+" + absAmount;
      }
      if (opt === "02") {
        return "-" + absAmount;
      }
      if (number > 0) {
        return "+" + number;
      }
      return String(number);
    },
    formatStaffInfo(row) {
      var adminName = row.companyStaffName|| "";
      // var adminAcc = row.adminAcc || "";
      // if (adminName && adminAcc) {
      //   return adminName + "-" + adminAcc;
      // }
      return adminName ||  "--";
    },
    downloadBlob(content, fileName) {
      var blob = new Blob([content]);
      var reader = new FileReader();
      reader.addEventListener("loadend", () => {
        try {
          var data = JSON.parse(reader.result);
          if (data.code === 0) {
            this.$message.error(data.msg || "服务异常");
          }
        } catch (err) {
          if ("download" in document.createElement("a")) {
            var elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          } else {
            navigator.msSaveBlob(blob, fileName);
          }
        }
      });
      reader.readAsText(blob, "utf-8");
    },
    formatMoneyNumber(value) {
      var number = Number(value);
      if (Number.isNaN(number)) {
        return 0;
      }
      return Number(number.toFixed(2));
    },
  },
};
</script>

<style lang="scss" scoped>
.refresh-icon {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.refresh-icon.is-rotating {
  animation: refresh-rotate 0.8s linear infinite;
}

@keyframes refresh-rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/deep/ .adjust-dialog {
  border-radius: 10px;
  overflow: hidden;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }
}

.drawer-card {
  background: #fff;
  overflow: hidden;
}

.drawer-header {
  height: 48px;
  padding: 0 18px;
  background: #0981ff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;

  i {
    color: #fff;
    font-size: 26px;
    cursor: pointer;
  }
}

.drawer-body {
  padding: 24px 24px 22px;

  /deep/ .el-form-item {
    margin-bottom: 16px;
  }

  /deep/ .el-form-item__label {
    color: #666;
    line-height: 36px;
    text-align: left;
  }

  /deep/ .el-input {
    width: 320px;
  }

  /deep/ .el-input__inner {
    height: 36px;
    line-height: 36px;
  }
}

.adjust-type-radios {
  /deep/ .el-radio-button__inner {
    min-width: 146px;
    height: 36px;
    line-height: 34px;
    padding: 0 16px;
  }
}

.amount-error {
  margin-top: 6px;
  color: #f56c6c;
  font-size: 12px;
  line-height: 18px;
}

.account-preview {
  padding-top: 18px;
  border-top: 1px solid #f0f2f5;
}

.flow-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  color: #333;
  font-size: 15px;
  font-weight: 600;

  em {
    color: #778399;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
  }
}

.flow-card {
  min-height: 148px;
  border: 1px solid #e8eef8;
  border-radius: 6px;
  background: #f8fbff;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: border-color 0.2s ease, background 0.2s ease;

  &.is-danger {
    border-color: #f56c6c;
    background: #fff8f8;

    .flow-out {
      border-color: #f56c6c;
      background: #fff;
    }

    .flow-out .flow-after strong {
      color: #f56c6c;
    }
  }
}

.flow-account {
  width: 210px;
  min-height: 116px;
  border: 1px solid #dfe9f7;
  border-radius: 6px;
  background: #fff;
  padding: 12px 14px;
  box-sizing: border-box;
}

.flow-label {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.flow-account-name {
  margin: 4px 0 10px;
  color: #17233d;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
}

.flow-balance,
.flow-after {
  color: #606266;
  font-size: 13px;
  line-height: 22px;

  strong {
    color: #17233d;
    font-size: 15px;
    font-weight: 600;
  }
}

.flow-out .flow-account-name {
  color: #f56c6c;
}

.flow-in .flow-account-name {
  color: #0981ff;
}

.flow-center {
  width: 136px;
  min-height: 116px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #0981ff;
  position: relative;
}

.flow-amount {
  width: 126px;
  height: 34px;
  padding: 0 8px;
  box-sizing: border-box;
  border-radius: 17px;
  background: #fff;
  border: 1px solid #c6dcff;
  box-shadow: 0 4px 12px rgba(9, 129, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #0981ff;
    font-size: 14px;
    font-weight: 600;
  }

  em {
    margin-left: 3px;
    color: #778399;
    font-size: 12px;
    font-style: normal;
  }
}

.flow-center i {
  margin-top: 8px;
  font-size: 22px;
}

.balance-warning {
  margin-top: 12px;
  min-height: 34px;
  border-radius: 4px;
  background: #fff3f3;
  border: 1px solid #ffd6d6;
  color: #f56c6c;
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-size: 13px;

  i {
    margin-right: 6px;
    font-size: 16px;
  }
}

.drawer-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 30px;

  .el-button {
    width: 90px;
    height: 36px;
    padding: 0;

    & + .el-button {
      margin-left: 22px;
    }
  }

  .el-button--default {
    color: #0981ff;
    border-color: #0981ff;
  }
}
</style>
